import omitBy from 'lodash-es/omitBy'

import { EMPTY_LIST } from '../../../../../constants/common'
import { PHASE_STRIP_SEARCH_PARAM } from '../../RentalPortalPhaseBar.constants'

export function getPhaseStripInitialPicked({ isPreview, searchParams }) {
  const paramKey = isPreview ? null : searchParams.get(PHASE_STRIP_SEARCH_PARAM)

  return paramKey ? { key: paramKey } : null
}

export function getPhaseStripOpenKey({ activePhaseKey, phases, pickedPhase }) {
  if (!pickedPhase) {
    return activePhaseKey ?? null
  }

  if (!pickedPhase.key) {
    return null
  }

  return (phases || EMPTY_LIST).some(phase => phase.key === pickedPhase.key)
    ? pickedPhase.key
    : (activePhaseKey ?? null)
}

export function checkHasPhaseStripStaleParam({
  isPreview,
  openPhaseKey,
  paramKey,
  phases,
}) {
  return Boolean(
    !isPreview && phases?.length > 0 && paramKey && paramKey !== openPhaseKey
  )
}

export function getPhaseStripToggledKey({ openPhaseKey, phaseKey }) {
  return phaseKey === openPhaseKey ? null : phaseKey
}

export function getPhaseStripSearchParams({ phaseKey, searchParams }) {
  return omitBy(
    {
      ...Object.fromEntries(searchParams.entries()),
      [PHASE_STRIP_SEARCH_PARAM]: phaseKey,
    },
    value => !value
  )
}
